import { countries } from "countries-list";
import moment from "moment";
import { db } from "../../connection";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";

let countrtyNameCodeMap = {};
Object.keys(countries).forEach((key) => {
  countrtyNameCodeMap[key] = countries[key].name;
});

export async function fbGetClubAdminPolls(groupId) {
  // let members = await fbGetClubAdminMembers(null);
  // let allGroups = await getGroups();

  let polls = await getDocs(
    collection(db, "parentGroups", groupId, "polls"),
  ).then((snap) => {
    let result = [];
    snap.docs.forEach((doc) => {
      let stats = {};
      let optKeys = ["op1", "op2", "op3", "op4", "op5"];
      optKeys
        .filter((key) => doc.data()[key] && doc.data()[key] !== null)
        .forEach((key) => {
          stats[doc.data()[key].name] =
            (doc.data()[key].votes * 100) / doc.data().noOfPolls;
          if (isNaN(stats[doc.data()[key].name])) {
            stats[doc.data()[key].name] = 0;
          }
        });

      // const pollGroups = doc.data().groups || ["global"];
      // const targetMembersCount = calculateTargetMemberCount(
      //   members,
      //   pollGroups,
      //   allGroups
      // );

      result.push({ ...doc.data(), id: doc.id, stats });
    });
    return result;
  });

  let filteredPolls = polls.filter((poll) => !poll.isActive);
  polls = [
    ...polls
      .filter((poll) => poll.isActive && moment().unix() < poll.closesOn)
      .sort((a, b) => b.addedOn - a.addedOn),
    ...polls
      .filter((poll) => poll.isActive && moment().unix() > poll.closesOn)
      .sort((a, b) => b.addedOn - a.addedOn),
    ...filteredPolls.sort((a, b) => b.addedOn - a.addedOn),
  ];
  return polls;
}

export async function getPoll(groupId, id) {
  let data = await getDoc(doc(db, "parentGroups", groupId, "polls", id)).then(
    (doc) => {
      return doc.data();
    },
  );
  return data;
}

export async function deletePolls(groupId, pollId) {
  try {
    await deleteDoc(doc(db, "parentGroups", groupId, "polls", pollId));
    return { success: true, message: "Poll deleted successfully" };
  } catch (error) {
    return { success: false, message: "Failed to delete poll" };
  }
}

export async function postLive(groupId, id) {
  let docRef = doc(db, "parentGroups", groupId, "polls", id);

  let doc = await getDoc(docRef).then((doc) => doc.data());

  let data = {
    isActive: true,
    postedOn: moment().unix(),
    closesOn:
      moment().unix() +
      doc.duration.days * 24 * 60 * 60 +
      doc.duration.hours * 60 * 60,
  };
  await docRef.update({ ...data });
}
